import React from "react";

const Chapter2 = () => {
  return (
    <>
      <h2>What are nutrients?</h2>
      <p>
        Nitrogen and phosphorus are nutrients that are natural parts of aquatic
        ecosystems. Nitrogen and phosphorus support the growth of algae and
        aquatic plants, which provide food and habitat for fish, shellfish and
        smaller organisms that live in water.
      </p>
      <p>
        Nutrient pollution is caused by excess phosphorus and nitrogen
        (typically in the form of nitrate or ammonia or orthophosphate) in
        rivers, lakes and streams.
      </p>
      <h3>Phosphorus</h3>
      <p>
        Phosphorus is a chemical element with symbol P and atomic number 15.
        Dissolved forms of phosphorus including orthophosphate are readily
        bioavailable for uptake by algae. In aquatic systems, low phosphate
        levels are an important limit to growth, while high phosphate levels
        encourage algae growth and can have negative consequences for the
        environment. Phosphorus is most commonly used as a fertilizer. Other
        uses include organophosphorus compounds in detergents, pesticides, and
        nerve agents.
      </p>
      <h3>Nitrate</h3>
      <p>
        Nitrate is an ion with the molecular formula NO3. Nitrate is composed of
        the elements oxygen and nitrogen, and is an important source of nitrogen
        for plant and animal life. Common sources of nitrate in water include
        decomposing plant and animal matter, human and animal waste, wastewater
        treatment plants, household septic systems, and fertilizers. Because it
        dissolves readily in water, nitrate from these sources is usually
        present at least in low concentrations in streams and lakes.
      </p>
      <h3>Ammonia</h3>
      <p>
        Ammonia is a compound of nitrogen and hydrogen with the formula NH3.
        Ammonia is the preferred nitrogen-containing nutrient for plant growth.
        Ammonia can be converted to nitrite (NO2) and nitrate (NO3) by bacteria,
        and then used by plants. Nitrate and ammonia are common forms of
        nitrogen in aquatic systems, but nitrate predominates in most waters.
      </p>
      <p>
        Ammonia is excreted by animals and produced during decomposition of
        plants and animals, thus returning nitrogen to the aquatic system.
        Ammonia can also come from domestic, industrial or agricultural
        pollution, primarily from fertilizers, organic matter, or fecal matter.
      </p>
      <p>
        Ammonia is an interesting pollutant because at low concentrations it is
        an important nutrient. At higher concentrations, it can be toxic,
        causing lower reproduction and growth, or death of aquatic life.
      </p>
    </>
  );
};

export default Chapter2;
